import { UserDto } from './user.dto';
import { EventDto } from './event.dto';
import { EventAttendanceOptionsEnum, EventUserRolesEnum } from '../../enums';
import {
	IsDate,
	IsEmail,
	IsEnum,
	IsIn,
	IsOptional,
	IsPhoneNumber,
	IsString,
	MinLength,
	ValidateIf,
} from 'class-validator';
import { Transform } from 'class-transformer';
import { dateStringToDateOptional } from '../../types-transformers';
import { EventPriceDto } from './event-price.dto';
import { IntakeFormDataToEventDto } from './intake-form-data-to-event.dto';
import { IntakeFormUserDataResults } from './intake-form-settings.dto';

export class EventToUserDto {
	id: string;
	eventId: string;
	userId: string;
	actualFrom: Date;
	actualTo?: Date;
	userRoleId: EventUserRolesEnum;
	acceptanceOptionId?: EventAttendanceOptionsEnum;
	quantity: number;
	isSpotAvailable: boolean;
	createdAt: Date;
	updatedAt: Date;
	deletedAt?: Date;

	orderId?: string;

	user?: UserDto;
	event?: EventDto;
	prices?: EventPriceDto[];
	intakeFormResults?: IntakeFormDataToEventDto;
}

export enum EventToUserPeriodTypeEnum {
	Termless = 'TERMLESS',
	SingleDay = 'SINGLE_DAY',
}

export class EventToUserOptions {
	@Transform(dateStringToDateOptional)
	@IsDate()
	@IsOptional()
	instance?: Date;

	@IsEnum(EventToUserPeriodTypeEnum)
	type: EventToUserPeriodTypeEnum;

	@IsIn([
		EventAttendanceOptionsEnum.Accepted,
		EventAttendanceOptionsEnum.Declined,
		EventAttendanceOptionsEnum.Waitlisted,
	])
	@IsOptional()
	acceptanceOptionId?:
		| EventAttendanceOptionsEnum.Accepted
		| EventAttendanceOptionsEnum.Declined
		| EventAttendanceOptionsEnum.Waitlisted;

	ticketQuantity?: number;
}

export class JoinEventBody {
	@IsOptional()
	intakeFormResults?: IntakeFormUserDataResults;

	referralCode?: string;
	preselectedTierId?: string;
}

export class PublicJoinEventBody extends JoinEventBody {
	@IsString()
	@MinLength(3)
	fullName: string;

	@IsString()
	@IsPhoneNumber()
	phone: string;

	@IsString()
	@IsEmail()
	email: string;

	@ValidateIf(o => !o.recaptchaTokenV2 && !o.recaptchaTokenV3 && !o.e2eToken, {
		message: 'Either code or recaptchaToken is required',
	})
	@IsString()
	code?: string;

	@ValidateIf(o => !o.code && !o.recaptchaTokenV3 && !o.e2eToken, {
		message: 'Either code or recaptchaToken is required',
	})
	@IsString()
	recaptchaTokenV2?: string;

	@ValidateIf(o => !o.code && !o.recaptchaTokenV2 && !o.e2eToken, {
		message: 'Either code or recaptchaToken is required',
	})
	@IsString()
	recaptchaTokenV3?: string;

	@ValidateIf(o => !o.code && !o.recaptchaTokenV2 && !o.recaptchaTokenV3, {
		message: 'Either code or recaptchaToken is required',
	})
	@IsString()
	e2eToken?: string;
}

export interface EventToUserPeriod {
	actualFrom: Date;
	actualTo: Date | null;
}
